import Api from "./Api";

async function getBills(token,params,cancelToken){
    const response=await Api.get('/api/v1/Providers/Bills/History',{
        params,
        headers: {
            "Authorization": `Bearer ${token}`
        },
        cancelToken
    });

    return response;
}
export default getBills;